import type { ISerialize } from '@/objects/ISerialize';

export class TransactionResponse implements ISerialize {
    public TUID: string | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { TUID?: string | null }) {
        this.TUID = values.TUID ?? null;
    }

    public serialize(): string {
        return '{' + `"TUID": ${JSON.stringify(this.TUID)}` + '}';
    }

    /**
     * Creates an instance of TransactionResponse from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { TUID?: string | null }): TransactionResponse {
        return new TransactionResponse(values);
    }

    public static _FromServerJson(json: any): TransactionResponse {
        return new TransactionResponse({ TUID: json.TUID ?? '' });
    }

    /**
     * Creates an instance of TransactionResponse from another instance of TransactionResponse.
     * @param other The TransactionResponse you want to clone
     * @returns A cloned TransactionResponse
     */
    public static FromOther(other: TransactionResponse): TransactionResponse {
        return TransactionResponse._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return TransactionResponse.FromOther(this);
    }

    static NAME_OF_CLASS = 'TransactionResponse';
}
